import React from 'react';
import { Search, Plus } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section className="bg-cream py-16 md:py-[84px]" data-id="element-21" data-mp="zpm9x0mqksk4">
      <div className="mx-auto max-w-[780px] px-5" data-id="element-22" data-mp="zpckpf9impfh">
        <SectionHeading kicker="Preguntas frecuentes" icon={Search} title={<>
              Resolvemos tus <em data-id="element-24" data-mp="71qfk2kn3cqi">dudas</em>
            </>} data-id="element-23" data-mp="ur2iwltacqkw" />
        <div className="mt-10 flex flex-col gap-3" data-id="element-25" data-mp="22n8ydp0gygf">
          {faqs.map(f => <details key={f.question} className="group overflow-hidden rounded-[18px] border border-line bg-white" data-id="element-26" data-mp="gze8cmyoqa61">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-[18px] font-display text-base md:px-6 md:py-5 md:text-[17px] font-semibold text-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-tangerine" data-id="element-27" data-mp="bzrxgk6bx60e">
                {f.question}
                <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-cream text-tangerine transition-transform duration-200 ease-out group-open:rotate-45" data-id="element-28" data-mp="ht7ieo6zbpxv">
                  <Plus className="h-[18px] w-[18px]" strokeWidth={3} aria-hidden="true" data-id="element-29" data-mp="rsevrbdprkkz" />
                </span>
              </summary>
              <p className="px-5 pb-5 text-[15.5px] text-muted md:px-6 md:pb-[22px] md:text-base" data-id="element-30" data-mp="3v8m1dnfovrwe">{f.answer}</p>
            </details>)}
        </div>
      </div>
    </section>;
}